define('views/modules/calendar/animated-session/exercise/lists/print/print-exercise-list-item',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/modules/calendar/animated-session/exercise/weight/week-brief/weight-brief-content',
    'views/modules/calendar/animated-session/exercise/cardio/week-brief/cardio-brief-content',
    // parent view
    'views/modules/calendar/animated-session/exercise/lists/exercise-list-item',
    // templates
    'text!templates/modules/calendar/animated-session/exercise/lists/print/print-exercise-list-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // views
    VWeightBriefContent,
    VCardioBriefContent,
    // parent view
    VExerciseListItem,
    // templates
    TPrintExerciseListItem
) {

    var VPrintExerciseListItem = VExerciseListItem.extend({
        template: TPrintExerciseListItem,
        weightContentView: VWeightBriefContent,
        cardioContentView: VCardioBriefContent,

        onLinkClick: _.noop,


        render: function() {
            var notes = this.truncateText(this.model.attributes.notes, 162);
            var model = this.model,
                animation = model.getAnimation(),
                $html = Backbone.$(Mustache.render(this.template, Mustache.getContext(_.extend(model.toJSON(), {
                    isDone: this.isWeekView() ? this.getWeekDone() : false,
                    hideTCNotes: model.get('hideTCNotes'),
                    isWeekView: this.isWeekView(),
                    isClientSide: this.role === 'client',
                    notes: notes
                }))));

            this.$el.replaceWith($html);
            this.setElement($html).applyAttributes();

            this.applyBindings();

            this.generateZones();

            // if there is custom notes OR notes that described the exercise
            if (model.hasNotes() && this.options.summary) {
                this.toggleNote(true);
            }

            this.addTimestampToThumbnail();

            this.renderContent();

            return this;
        },

        truncateText: function(text, numberOfCharacter) {

            if (text.length <= numberOfCharacter) {
                return text;
              }

            return text.slice(0, numberOfCharacter);

        },

    });



    return VPrintExerciseListItem;

});

